import { API_BASE_URL, getAuthHeaders } from './utils';
import { CEFR_LEVELS } from './cefrUtils';

export const isIeltsProfileAssessed = (profile) => {
  if (!profile || profile.assessed !== true) return false;
  return Boolean(profile.current_level && CEFR_LEVELS[profile.current_level]);
};

export const readSpeakingBandScore = (result) => {
  const score =
    result?.assessment_data?.assessment?.overallBandScore ??
    result?.assessment_data?.overallBandScore ??
    result?.results?.assessment?.overallBandScore ??
    result?.results?.overallBandScore ??
    result?.overallBandScore;
  const value = Number(score);
  return Number.isFinite(value) ? value : null;
};

export const fetchIeltsProfile = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/ielts/profile`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) return null;
    return response.json();
  } catch (error) {
    console.warn('Failed to fetch IELTS profile', error);
    return null;
  }
};

export const updateIeltsProfile = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/api/ielts/profile`, {
    method: 'PUT',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to update IELTS profile (${response.status})`);
  }
  return response.json();
};
